"use client"
import * as React from "react"
import { Playfair_Display, Lato } from "next/font/google"
import { ThemeProvider } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"
import theme from "@/theme/theme"
import { AppRouterCacheProvider } from "@mui/material-nextjs/v15-appRouter"
import { SpeedInsights } from "@vercel/speed-insights/next"
import { Analytics } from "@vercel/analytics/next"
import Script from "next/script"

declare global {
  interface Window {
    dataLayer: unknown[]
  }
}

const playfair = Playfair_Display({
  subsets: ["latin"],
  variable: "--font-display",
  display: "swap",
})

const lato = Lato({
  weight: ["300", "400", "700"],
  subsets: ["latin"],
  variable: "--font-primary",
  display: "swap",
})

export default function RootLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <html lang="fr" className={`${playfair.variable} ${lato.variable}`}>
      <head>
        <title>Amaurisse | Mariage</title>
        <meta
          name="description"
          content="Site pour l'événement de mariage d'Amaurisse"
        />
        {/* Google Tag Manager HEAD */}
        <Script
          id="gtm-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-5FPBDMH7');
    `,
          }}
        />
      </head>
      <body>
        <div
          dangerouslySetInnerHTML={{
            __html: `
      <noscript>
        <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-5FPBDMH7"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      </noscript>
    `,
          }}
        />
        <AppRouterCacheProvider>
          <ThemeProvider theme={theme}>
            <CssBaseline />
            {children}
            <Analytics />
            <SpeedInsights />
          </ThemeProvider>
        </AppRouterCacheProvider>
      </body>
    </html>
  )
}
